// removed by extract-text-webpack-plugin
module.exports = {"tabActiveButton":"D8sSv","tabInactiveButton":"_14lEm","card":"_3nsha","noPadding":"_3z1cc","cardAdmin":"_2Ah_-"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Card/Card.scss
// module id = 1627
// module chunks = 0